
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon } from '@mui/material';

import VideoEmbedded from '../../components/controls/VimeoEmbedded';

const PageOver: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <header className="page-header container">
        <h1>Over infraplannen.nl</h1>
        <p className="header-sub-title">
          Infraplannen.nl is een landelijk platform waar netbeheerders onderling en met partijen zoals gemeenten, provincies en waterschappen, strategische plannen delen en afstemmen. 
          Elke aangesloten organisatie deelt plannen vanuit een eigen bron, via IT-koppelingen of via een export uit een GIS-systeem. 
          De IT-koppelingen zorgen voor continue synchronisatie van actuele planinformatie. Zo maakt infraplannen.nl integraal programmeren zo eenvoudig mogelijk.
        </p>
      </header>

      <section>
        <div className="page-content container">
          <div className="row">
            <div className="col-12">
              {/* <Paper className="paper-content">content</Paper> */}
              <h4>Een initiatief van Stichting Mijn Aansluiting</h4>
              <p>
                Infraplannen.nl is ontwikkeld en wordt beheerd door <a href="https://stichting.mijnaansluiting.nl/over-de-stichting/" target="_blank" rel="noopener noreferrer">Stichting Mijn Aansluiting</a>, 
                in opdracht van de samenwerkende <a href="https://stichting.mijnaansluiting.nl/over-de-stichting/onze-deelnemers" target="_blank" rel="noopener noreferrer">netbeheerders</a>. 
                Stichting Mijn Aansluiting biedt sinds 2013 gebruiksvriendelijke proces- en IT-oplossingen voor klanten en ketenpartners in de infrastructuursector. 
                Het landelijk aanvraagportaal en uniform opdrachtensysteem worden inmiddels door alle netbeheerders gebruikt.
              </p>
              <p>
                De dienst infraplannen.nl is gericht op het efficiënter afstemmen van strategische plannen drie tot vijftien jaar vooruit.
              </p>
              <Button variant="text" color="secondary" onClick={ () => navigate('/toegang-tot-infraplannen') }>
                Toegang tot infraplannen.nl
                <Icon>chevron_right</Icon>
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="page-content container">
          <div className="row">
            <div className="col-12">
              <h4>Sector-brede voordelen</h4>
              <p>
                Netbeheerders, waterschappen, provincies, gemeenten en anderen die deels werkzaam zijn in de ondergrond, hebben hun eigen opgaven in overlappende gebieden. 
                Integraal programmeren - ofwel integrale planafstemming - tussen deze partijen biedt vele voordelen zoals efficiëntere inzet van capaciteit, minder overlast voor bewoners en financiële besparingen. 
              </p>

              <VideoEmbedded 
                type="vimeo" 
                id="1146920829" 
                title="Video infraplannen.nl" />

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PageOver;